import React, { useState } from "react";
import RoiCalculatorWidget from "./RoiCalculatorWidget";
import Modal_started from "../Home/Modal_started";
import { useTranslation } from "react-i18next";

const Ecommerce_new = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  const features = [
    {
      tag: "Inventario al día",
      title: "Gestión de inventario automática",
      description:
        "Que reduzca pérdidas, avise cuando falten ingredientes y permita compras inteligentes.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-INVENTARIO-AUTOMATICA_kow1hl.png",
    },
    {
      tag: "Facturación electrónica",
      title: "Facturación digital eficiente",
      description:
        "Genera facturas electrónicas al instante, lleva un control de tus ventas y cumple con todos los requisitos fiscales sin complicaciones.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/FACTURACION-DIGITAL-EFICIENTE_bzc8pt.png",
    },
    {
      tag: "Control de mesas",
      title: "Gestión del personal",
      description:
        "Control de turnos, comisiones, rendimiento y roles dentro del sistema.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-PERSONAL_jzcmhm.png",
    },
    {
      tag: "InvuReport",
      title: "Reportes avanzados de ventas",
      description:
        "Gráficos y análisis por plato, turno, mes o empleado para tomar decisiones rápidas.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/REPORTES-AVANZADOS-DE-VENTAS_wzaucp.png",
    },
    {
      tag: "Control de mesas",
      title: "Control de mesas y reservas",
      description:
        "Visualización clara de ocupación, tiempos de permanencia y disponibilidad en tiempo real.",
      image:
        "https://img.invupos.com/webinvu/homenew/Whatsapp%20Catalogo-12%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Manejo de promociones",
      description:
        "Crear ofertas, combos y descuentos fácilmente sin afectar inventario ni contabilidad.",
      image:
        "https://img.invupos.com/webinvu/homenew/invu%20mockups%20multiple%20screens%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Para franquicias o sucursales",
      description:
        "Administración centralizada si tienen más de un local, con reportes consolidados.",
      image:
        "https://img.invupos.com/webinvu/homenew/1%202.png",
    },
  ];

  const features1 = [
    { text: "Reduce costos operativos" },
    { text: "Ofrece múltiples métodos de pago" },
    { text: "Gestiona fácilmente tu inventario" },
    { text: "Crea promociones y descuentos" },
    { text: "Facilita la actualización del menú" },
    { text: "Impulsa la fidelización" },
    { text: "Mayor satisfacción" },
    { text: "Sistema todo integrado" },
    { text: "Reportes en tiempo real" },
    { text: "Delivery en segundos" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + features.length) % features.length);
  };

  // ✅ Siempre devuelve 3 cards, ciclando los índices con módulo
  const getVisibleCards = () => {
    const cards = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % features.length;
      cards.push({ ...features[index], originalIndex: index });
    }
    return cards;
  };

  const faqs = [
    {
      question: "¿Qué es el Ecommerce de Invu POS y cómo ayuda a mi negocio? ",
      answer:
        "Es una tienda en línea integrada directamente a tu POS. Te permite recibir pedidos desde tu página web sin comisiones de terceros, con control total de tu inventario, precios y promociones. Cada orden entra al sistema en tiempo real, lista para preparar y entregar.",
    },
    {
      question: "¿Necesito conocimientos técnicos para configurarlo?",
      answer:
        "No. Nuestro Ecommerce está diseñado para que cualquier comercio pueda activarlo en minutos. Solo cargas tu menú o catálogo, ajustas horarios, métodos de entrega y listo. Tu tienda queda activa con diseño profesional y navegación rápida. ",
    },
    {
      question: "¿Cómo se conectan los pedidos online con mi operación interna?",
      answer:
        "Todos los pedidos se integran automáticamente con Invu POS. El sistema actualiza inventario, envía la orden a cocina o bodega, y registra el pago. Tu equipo no necesita digitarlos manualmente, evitando errores y retrasos. ",
    },
    {
      question: "¿Qué métodos de entrega soporta el Ecommerce?",
      answer:
        "Puedes ofrecer pickup, delivery propio o delivery tercerizado. El cliente elige la opción que más le convenga, y tú controlas zonas, tarifas y tiempos. Incluso puedes conectar tu Ecommerce con plataformas de repartidores aliados. ",
    },
    {
      question: "¿Cómo pago y cómo pagan mis clientes? ",
      answer:
        "Tu tienda acepta pagos con tarjetas, transferencias, wallets digitales y pagos contra entrega. Todo se liquida directamente a tu cuenta. Además, puedes activar cupones, combos y promociones sin depender de terceros. ",
    },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [isOpen, setIsOpen] = useState(false);
  // const extendedFeatures = [...features, ...features, ...features]; 
  const featuresList = t("features1ecommercenew", { returnObjects: true });
  const extendedFeaturesList = t("featuresecommercenew", { returnObjects: true });
  const faqList = t("faqsecommercenew", { returnObjects: true });

  const isMobile =
  typeof window !== "undefined" && window.innerWidth < 768;

const cardsPerSlide = isMobile ? 1 : 3;

  
  return (
    <>
     {isOpen && <Modal_started setIsOpen={setIsOpen} />}
      <div className="px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl">
          {/* Grid con proporciones personalizadas */}
          <div className="grid lg:grid-cols-[45%_55%] gap-12 items-center px-8">
            {/* Contenido de texto */}
            <div className="space-y-8">
              <h1 className="text-5xl md:text-6xl lg:text-5xl font-bold leading-tight">
              {t("hero_title1")} {" "}
                <span className="text-blue-600">{t("hero_title_span")}</span> {t("hero_title2")}
              </h1>

              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
              {t("hero_description")}
              </p>

              <button 
                 onClick={() => {
                  setIsOpen(true);
                }}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-16 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                {t("hero_cta")}
              </button>
            </div>

            {/* Imagen */}
            <div className="relative">
              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/Ecommerce_new/img1.png"
                  alt="Mockup Invu POS"
                  className="rounded-2xl w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="w-full py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-8">
        

        {/* --- Card 1 --- */}
        <div className="relative border-2 border-orange-400 rounded-2xl p-6 shadow-sm hover:shadow-md transition bg-white">
          <div className="absolute top-4 right-4">
            <div className="w-10 h-6 bg-[#00CF60] rounded-full flex items-center p-1">
              <div className="w-4 h-4 bg-[#fff] rounded-full ml-auto"></div>
            </div>
          </div>

          <h3 className="text-xl font-bold text-gray-900 leading-tight">
            {t("card1_title")}
          </h3>

          <p className="text-gray-700 mt-4 text-lg leading-relaxed">
            {t("card1_description")}
          </p>
        </div>

        {/* --- Card 2 --- */}
        <div className="relative border-2 border-orange-400 rounded-2xl p-6 shadow-sm hover:shadow-md transition bg-white">
          <div className="absolute top-4 right-4">
            <div className="w-10 h-6 bg-[#00CF60] rounded-full flex items-center p-1">
              <div className="w-4 h-4 bg-[#fff] rounded-full ml-auto"></div>
            </div>
          </div>

          <h3 className="text-xl font-bold text-gray-900 leading-tight">
            {t("card2_title")}
          </h3>

          <p className="text-gray-700 mt-4 text-lg leading-relaxed">
            {t("card2_description")}
          </p>
        </div>

        {/* --- Card 3 --- */}
        <div className="relative border-2 border-orange-400 rounded-2xl p-6 shadow-sm hover:shadow-md transition bg-white">
          <div className="absolute top-4 right-4">
            <div className="w-10 h-6 bg-[#00CF60] rounded-full flex items-center p-1">
              <div className="w-4 h-4 bg-[#fff] rounded-full ml-auto"></div>
            </div>
          </div>

          <h3 className="text-xl font-bold text-gray-900 leading-tight">
            {t("card3_title")}
          </h3>

          <p className="text-gray-700 mt-4 text-lg leading-relaxed">
            {t("card3_description")}
          </p>
        </div>

      </div>
    </section>

      <div className="min-h-screen bg-gray-50 px-6 py-16 md:py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Espacio para imagen del teléfono */}
            <div className="order-2 lg:order-1 flex justify-center">
              <div className="relative">
                <img
                  className="h-[750px]"
                  src="https://img.invupos.com/webinvu/Ecommerce_new/img2.png"
                />
              </div>
            </div>

            {/* Contenido de texto */}
            <div className="order-1 lg:order-2 space-y-8">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                {t("ctaecommercenew")}
              </h2>

              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                {t("ctaecommercedescriptionnew")}
              </p>

              {/* Grid de características */}
              <div className="grid sm:grid-cols-2 gap-4 pt-4">
                {featuresList.map((feature, index) => (
                  <div key={index} className="flex items-start gap-3 group">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mt-1 group-hover:scale-110 transition-transform duration-200">
                      <svg
                        className="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={3}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <span className="text-base md:text-lg font-semibold text-gray-900 leading-snug">
                      {feature.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12">
        <RoiCalculatorWidget />
      </div>

      <div className="min-h-screen bg-gray-100 py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left Card - Aliados */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden">
              {/* Header */}

              <h2 className="text-4xl lg:text-5xl font-bold text-black mb-8">
                <span className="text-blue-600">{t("allies_title_blue")}</span> {t("allies_title_rest")}
              </h2>

              {/* Description */}
              <p className="text-gray-700 text-lg leading-relaxed mb-12">
                {t("allies_description")}
              </p>

              {/* Imagen CLAU.IO */}
              <div className="relative bg-gray-50 rounded-2xl overflow-hidden h-80 mb-8 flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/Ecommerce_new/img3.png"
                  alt="Plataforma CLAU.IO"
                  className="w-full h-full object-contain"
                />
              </div>

              {/* CTA Button */}
              <a
              href="https://clau.io/"
              target="_blank"
              className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold text-xl px-12 py-5 rounded-full shadow-lg transition-all">
                {t("allies_cta")}
              </a>
            </div>

            {/* Right Card - Loyalty */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden flex flex-col">
              {/* Header */}
              <div className="text-center mb-8">
                <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                  <span className="text-black">{t("loyalty_title_black")} </span>
                  <span className="text-blue-600">{t("loyalty_title_blue")}</span>
                </h2>

                {/* Description */}
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {t("loyalty_description")}
                </p>

                {/* CTA Button */}
                <button 
                   onClick={() => {
                    setIsOpen(true);
                  }}
                className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-24 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                  {t("loyalty_cta")}
                </button>
              </div>

              {/* Imagen de celulares */}
              <div className="relative flex-1 flex items-end justify-center mt-8">
                <div className="w-full h-96 bg-gray-50 rounded-2xl overflow-hidden flex items-center justify-center">
                  <img
                    src="https://img.invupos.com/webinvu/Ecommerce_new/img4.png"
                    alt="Apps móviles Loyalty"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-8">
  <div className="max-w-7xl mx-auto">
    {/* Header */}
    <div className="flex flex-col lg:flex-row justify-between items-center gap-6 mb-12 text-center lg:text-left">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 max-w-2xl leading-tight">
        {t("reasons_title")}
      </h1>

      <button
        onClick={() => {
          setIsOpen(true);
        }}
        className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-base sm:text-lg px-10 sm:px-16 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
      >
        {t("reasons_cta")}
      </button>
    </div>

    {/* Carousel */}
    <div className="relative overflow-hidden">
      <div
        className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
        style={{
          transform: `translateX(-${currentSlide * (100 / cardsPerSlide)}%)`,
        }}
      >
        {extendedFeaturesList.map((feature, idx) => (
          <div
            key={idx}
            className="w-full md:w-1/3 flex-shrink-0 px-3 md:px-4 animate-fadeup"
            style={{ animationDelay: `${(idx % 3) * 0.1}s` }}
          >
            {/* Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-700 ease-in-out overflow-hidden h-full flex flex-col">
              {/* Brillo diagonal */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>

              {/* Borde brillante */}
              <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-blue-100 transition-all duration-700"></div>

              {/* Tag */}
              <div className="flex items-center justify-between mb-6">
                <span className="text-blue-600 font-semibold text-sm">
                  {feature.tag}
                </span>
                <div className="bg-blue-600 rounded-full p-1.5 flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-white"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M13 4L6 11L3 8"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                {feature.description}
              </p>

              {/* Image */}
              <div className="relative bg-white rounded-2xl overflow-hidden flex items-center justify-center h-64 mb-6">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="object-contain max-h-full max-w-full transition-transform duration-700 ease-in-out group-hover:scale-110"
                />
              </div>

              {/* Plus Button */}
              <div>
                <button className="mt-auto bg-blue-50 hover:bg-blue-100 rounded-full p-3 transition-transform duration-500 hover:scale-110 shadow-sm">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 4V16M4 10H16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botones */}
      <div className="flex justify-center gap-4 mt-6">
        <button
          onClick={prevSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Anterior"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          onClick={nextSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Siguiente"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Indicadores */}
      <div className="flex justify-center gap-2 mt-6">
        {features.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            className={`h-2 rounded-full transition-all ${
              idx === currentSlide
                ? "w-8 bg-blue-600"
                : "w-2 bg-gray-300 hover:bg-gray-400"
            }`}
            aria-label={`Ir a slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  </div>
</div>


      <div className="min-h-screen bg-white py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left Side - Imagen FAQ Ecommerce */}
            <div className="flex justify-center lg:justify-center">
              <img
                src="https://img.invupos.com/webinvu/Ecommerce_new/img5.png"
                alt="Preguntas frecuentes Ecommerce"
                className="object-contain w-[50%] max-w-[450px] h-auto"
              />
            </div>

            {/* Right Side - FAQ Section */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
                {t("faqtitle")}
              </h2>

              {/* FAQ Items */}
              <div className="space-y-4">
                {faqList.map((faq, index) => (
                  <div key={index} className="border-b border-gray-200">
                    <button
                      onClick={() => toggleFaq(index)}
                      className="w-full py-6 flex items-center justify-between text-left hover:text-gray-600 transition-colors"
                    >
                      <span className="text-lg font-medium text-gray-900 pr-4">
                        {faq.question}
                      </span>
                      <span className="text-2xl text-gray-500 flex-shrink-0">
                        {openIndex === index ? "−" : "+"}
                      </span>
                    </button>
                    {openIndex === index && (
                      <div className="pb-6 text-gray-600 leading-relaxed">
                        {faq.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA Banner */}
          <div className="mt-20 relative bg-gradient-to-r from-[#0056FB] to-[#003395] rounded-3xl p-12 overflow-hidden max-w-6xl mx-auto">
            {/* Decorative Circle */}
            <div className="absolute right-2 top-1/2 -translate-y-1/2 w-64 h-64 opacity-20">
              <img src="https://img.invupos.com/webinvu/Ecommerce_new/logo-INVU-POS-blanco_1_7_dvfhgc.png" />
            </div>

            <div className="relative z-10 max-w-3xl mx-auto text-center">
              <h3 className="text-3xl lg:text-5xl font-bold text-white mb-8 leading-tight">
                {t("cta2ecommercenewtitle")}
              </h3>
              <button 
                 onClick={() => {
                  setIsOpen(true);
                }}
              className="bg-white hover:bg-gray-100 text-blue-600 font-bold px-8 py-4 rounded-full transition-colors text-lg uppercase tracking-wide">
                {t("cta2ecommercenewbutton")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ecommerce_new;